import { COMPANY_ACCESS_RULE } from '../../../../frontend/global/modules/companies/api/enums/company-access-rule';
import { CompanyWorkspace } from '../../api/types/UserCompany.types';

export const getOwnPortal = (workspaces: CompanyWorkspace[]) => {
  for (const workspace of workspaces) {
    for (const portal of workspace.portals) {
      if (portal.access_rule === COMPANY_ACCESS_RULE.OWNER) {
        return portal;
      }
    }
  }
};
